/* unplugin-vue-components disabled */import script from "./add.vue?vue&type=script&setup=true&name=projectAdd&lang=js"
export * from "./add.vue?vue&type=script&setup=true&name=projectAdd&lang=js"

import "./add.vue?vue&type=style&index=0&id=2b800cc0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b800cc0"]])

export default __exports__